import React, { useState, createContext } from 'react';

import { useRouter } from 'next/router';

import { isBrowser } from '~/utils/isBrowser';

export interface AppContextProps {
  innerWidth: number;
  locale: 'en' | 'ja';
}

interface Props {
  children: React.ReactNode;
}

export const AppProvider = ({ children }: Props) => {
  // if we are in SSR, setting window width to desktop
  const [innerWidth] = useState(isBrowser() ? window.innerWidth : 1200);
  const router = useRouter();

  // this works great for now because we only have two languages
  // but this might need to change if we introduce more languages down the line
  const locale = router?.locale !== 'ja' ? 'en' : 'ja';
  return (
    <AppContext.Provider value={{ innerWidth, locale }}>
      {children}
    </AppContext.Provider>
  );
};

export const AppContext = createContext<AppContextProps | null>(
  null,
) as React.Context<AppContextProps>;
